import { render, staticRenderFns } from "./DownloadOTs.vue?vue&type=template&id=5e55883a&scoped=true&lang=pug"
import script from "./DownloadOTs.vue?vue&type=script&lang=js"
export * from "./DownloadOTs.vue?vue&type=script&lang=js"
import style0 from "./DownloadOTs.vue?vue&type=style&index=0&id=5e55883a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e55883a",
  null
  
)

export default component.exports